import React from 'react';
import { Col, Row } from 'reactstrap';
import { version } from '../../config';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="text-center text-lg-start text-white pt-5">
        {/* Grid container */}
        <div className="container p-4 pb-0 pt-5">
          {/* Section: Links */}
          <sec>
            {/* Grid row */}
            <div className="row pt-5" style={{ backgroundColor: '#45526e' }}>
              {/* Grid column */}
              <div className="col-md-3 col-lg-3 col-xl-3 mx-auto mt-3">
                <div className="bg-white p-3 rounded-3 mb-3">
                  <img src="/assets/images/logo.png" alt="Mergeasy Logo" className="img-fluid" />
                </div>
                <p>All-in-One Solution for Document Merging, eSignatures and Calling.</p>
              </div>
              {/* Grid column */}

              {/* Grid column */}
              <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mt-3">
                <h6 className="text-uppercase mb-4 " style={{ color: '#fff' }}>
                  Company Links
                </h6>
                <p>
                  <a className="text-white text-decoration-none" href="https://mergeasy.com">
                    Home
                  </a>
                </p>
                <p>
                  <a className="text-white text-decoration-none" href="https://mergeasy.com/about">
                    About
                  </a>
                </p>
                <p>
                  <a className="text-white text-decoration-none" href="https://mergeasy.com/privacypolicy">
                    Privacy Policy
                  </a>
                </p>
                <p>
                  <a className="text-white text-decoration-none" href="https://mergeasy.com/refundpolicy">
                    Refund Policy
                  </a>
                </p>
              </div>
              {/* Grid column */}

              {/* Grid column */}
              <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mt-3">
                <h6 className="text-uppercase mb-4" style={{ color: '#fff' }}>
                  Products
                </h6>
                <p>
                  <a className="text-white text-decoration-none" href="https://mergeasy.com/mergsign">
                    MergeSign
                  </a>
                </p>
                <p>
                  <a className="text-white text-decoration-none" href="https://mergeasy.com/mergcall">
                    MergeCall
                  </a>
                </p>
                <p>
                  <a className="text-white text-decoration-none" href="https://mergeasy.com/mergeasy">
                    Mergeasy
                  </a>
                </p>
              </div>
              {/* Grid column */}

              {/* Grid column */}
              <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mt-3">
                <h6 className="text-uppercase mb-4" style={{ color: '#fff' }}>
                  Contact
                </h6>
                <p>
                  <i className="fas fa-home mr-3" /> 651 N Broad St Suite 201, Middletown, DE 19709, US
                </p>
                <p>
                  <i className="fas fa-phone mr-3" /> +1 415 417 0410
                </p>
              </div>
              {/* Grid column */}
            </div>
            {/* Grid row */}
          </sec>
          {/* Section: Links */}

          {/* <hr className="my-3" /> */}

          {/* Section: Copyright */}
          <sec className="p-3 pt-0">
            <div className="row d-flex align-items-center">
              {/* Grid column */}
              <div className="col-md-7 col-lg-8 text-center text-md-start">
                {/* Copyright */}
                <div className="p-3" style={{ color: '#45526e' }}>
                  © 2024 Mergeasy:{' '}
                  <a href="https://mergeasy.com" style={{ color: '#45526e' }}>
                    Mergeasy.com
                  </a>
                </div>
                {/* Copyright */}
              </div>
              {/* Grid column */}

              {/* Grid column */}
              <div className="col-md-5 col-lg-4 ml-lg-0 text-center text-md-end">
                <a
                  className="btn btn-outline-light btn-floating m-1 text-white"
                  role="button"
                  href="https://www.facebook.com/mergeasy"
                  style={{ border: 'none' }}
                >
                  <i className="fab fa-facebook-f" style={{ color: '#45526e' }} />
                </a>
                <a
                  className="btn btn-outline-light btn-floating m-1 text-white"
                  role="button"
                  href="https://in.pinterest.com/mergeasy/pins/"
                  style={{ border: 'none' }}
                >
                  <i className="fab fa-pinterest" style={{ color: '#45526e' }} />
                </a>
                <a
                  className="btn btn-outline-light btn-floating m-1 text-white"
                  role="button"
                  href="https://www.linkedin.com/in/mergeasy-sm-96653a218/"
                  style={{ border: 'none' }}
                >
                  <i className="fab fa-linkedin" style={{ color: '#45526e' }} />
                </a>
                <a
                  className="btn btn-outline-light btn-floating m-1 text-white"
                  role="button"
                  href="https://www.instagram.com/mergeasydocuments/"
                  style={{ border: 'none' }}
                >
                  <i className="fab fa-instagram" style={{ color: '#45526e' }} />
                </a>
              </div>
              {/* Grid column */}
            </div>
          </sec>
          {/* Section: Copyright */}
        </div>
        {/* Grid container */}
      </div>
    </footer>
  );
};

export default Footer;
